<div id="{{'GameParameterGroup_' + this.GroupId}}">

</div>
<div style="font-size: x-small;color: gray;">Click on legend to hide/show parameters</div>
